var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalcOfFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C5.44771 2 5 1.55228 5 1C5 0.447715 5.44771 0 6 0V2ZM22 16C22 16.5523 21.5523 17 21 17C20.4477 17 20 16.5523 20 16H22ZM15 2H6V0H15V2ZM20 16V7H22V16H20ZM15 0C18.866 0 22 3.13401 22 7H20C20 4.23858 17.7614 2 15 2V0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 18,
    height: 18,
    rx: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcOfFiles);
export default __webpack_public_path__ + "static/media/calcOfFiles.6470684976eaea8f46668850d9c53092.svg";
export { ForwardRef as ReactComponent };